
import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar, IonPage, IonContent, IonItem, IonLabel, IonInput, useIonModal, IonBackButton, useIonActionSheet } from '@ionic/react';
import { create, ellipsisHorizontal, ellipsisVertical, helpCircle, search, star, peopleOutline, logOutOutline, addCircleOutline } from 'ionicons/icons';
import { OverlayEventDetail } from '@ionic/core/components';



function DogNav(props) {

  //const title = props.title;
  console.log(props);
  const [present] = useIonActionSheet();
  const [result, setResult] = useState<OverlayEventDetail>();
  const history = useHistory();
  const dog = props.dog;


  return (
    <IonToolbar>

      <IonTitle>{dog.name}</IonTitle>
      <IonButtons slot="primary">
        <IonButton
          onClick={() =>
            present({
              header: 'Example header',
              subHeader: 'Example subheader',
              buttons: [
                {
                  text: 'Delete',
                  role: 'destructive',
                  data: {
                    action: 'delete',
                  },
                },
                {
                  text: 'Update',
                  data: {
                    action: 'update',
                  },
                },
                {
                  text: 'Update Picture',
                  data: {
                    action: 'update picture',
                  },
                },
                {
                  text: 'Cancel',
                  role: 'cancel',
                  data: {
                    action: 'cancel',
                  },
                },
              ],
              onDidDismiss: ({ detail }) => {
                console.log(detail);
                if (detail.data.action === 'delete') {
                  console.log(detail.data.action);
                  props.deleteDog();
                }

                if (detail.data.action === 'update') {
                  // props.updateCommand();
                  console.log("Update")
                  props.setEditing(true);
                }

                if (detail.data.action === 'update picture') {
                  // props.updateCommand();
                  console.log("Update picture")
                  props.setUpdateProfilePicture(true);
                }
              },
            })
          }
        >
          <IonIcon slot="icon-only" icon={ellipsisHorizontal}></IonIcon>
        </IonButton>

      </IonButtons>
    </IonToolbar>

  );
}
export default DogNav;